/* Stykhia photo upload (buy block, step 3).
   UI only. The file input is part of the product form (form="product-form-<id>"), so Dawn's own
   FormData(form) sends it. This script never submits the form and never touches product-form.js:
   - shows a local thumbnail (URL.createObjectURL, nothing is uploaded here), the file name and "Change photo";
   - rejects photos above the size limit (message, field cleared);
   - the field is `required`; the form has novalidate, so a click on the submit button is stopped while no
     photo is chosen and the message is shown. With a photo the click goes through untouched. */
(function () {
  function init(root) {
    if (root.dataset.smReady) return;
    root.dataset.smReady = 'true';

    var input = root.querySelector('input[type="file"]');
    var area = root.querySelector('[data-sm-upload-area]');
    var selected = root.querySelector('[data-sm-upload-selected]');
    var thumb = root.querySelector('[data-sm-upload-thumb] img');
    var nameEl = root.querySelector('[data-sm-upload-name]');
    var errorEl = root.querySelector('[data-sm-upload-error]');
    if (!input) return;

    var maxBytes = (parseFloat(root.dataset.maxMb) || 20) * 1024 * 1024;
    var msgRequired = root.dataset.msgRequired || 'Please add a photo first';
    var msgLarge = root.dataset.msgLarge || 'This photo is too large.';
    var objectUrl = null;

    function showError(text) {
      errorEl.textContent = text;
      errorEl.hidden = false;
      root.classList.add('has-error');
    }

    function clearError() {
      errorEl.hidden = true;
      errorEl.textContent = '';
      root.classList.remove('has-error');
    }

    function reset() {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = null;
      thumb.hidden = true;
      thumb.removeAttribute('src');
      selected.hidden = true;
      area.hidden = false;
      root.classList.remove('is-selected');
      input.setCustomValidity(msgRequired);
    }

    function onChange() {
      var file = input.files && input.files[0];
      if (!file) {
        reset();
        return;
      }
      if (file.size > maxBytes) {
        input.value = '';
        reset();
        showError(msgLarge);
        return;
      }
      clearError();
      input.setCustomValidity('');
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      objectUrl = URL.createObjectURL(file);
      thumb.hidden = false;
      thumb.onerror = function () {
        /* a format the browser cannot draw (for example HEIC): no thumbnail, the file is still attached */
        thumb.hidden = true;
      };
      thumb.src = objectUrl;
      nameEl.textContent = file.name;
      selected.hidden = false;
      area.hidden = true;
      root.classList.add('is-selected');
    }

    input.setCustomValidity(msgRequired);
    input.addEventListener('change', onChange);
    input.addEventListener('invalid', function (event) {
      event.preventDefault();
      if (!errorEl.textContent || errorEl.textContent === msgLarge) showError(msgRequired);
    });

    /* Add to Cart without a photo: stop the click (no submit), show the message, scroll to the field.
       A grouped field (one of several, portrait template) is checked by assets/sm-portrait.js instead,
       which calls input.checkValidity(): the "invalid" handler above shows the message. */
    var button = document.getElementById('ProductSubmitButton-' + root.dataset.sectionId);
    if (button && !root.hasAttribute('data-sm-upload-grouped')) {
      button.addEventListener(
        'click',
        function (event) {
          if (input.files && input.files.length) return;
          event.preventDefault();
          event.stopImmediatePropagation();
          showError(msgRequired);
          var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          root.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          input.focus({ preventScroll: true });
        },
        true
      );
    }
  }

  function run() {
    document.querySelectorAll('[data-sm-upload]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
